import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from "react-redux";
import store from './Redux Components/store';
import reportWebVitals from './reportWebVitals';
import {ConfigProvider} from 'antd';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <React.StrictMode>
  <ConfigProvider
  theme={{
    token: {
      colorPrimary: '#0A66C2',   // Corporate blue
      colorBgBase: '#FFFFFF',    // Sidebar & base background white
      colorTextBase: '#1A1A1A',  // Dark gray text
      borderRadius: 6,
      fontSize: 12,
      controlHeight: 28,
      paddingXS: 4,
      paddingSM: 6,
      padding: 8,
      marginXS: 2,
      marginSM: 4,
    },
    components: {
      Layout: {
        headerBg: '#0A66C2',     // Blue header
        headerColor: '#FFFFFF',  // White text in header
        siderBg: '#FFFFFF',      // White sidebar
        triggerBg: '#FFFFFF',
        triggerColor: '#0A66C2',
      },
      Table: {
        headerBg: '#f0f2f5',
        headerColor: '#1A1A1A',
        rowHoverBg: '#e6f7ff',
        fontSize: 12,
        borderColor: '#d9d9d9',
        padding: 6,
      },
      Card: {
        headerFontSize: 13,
        padding: 8,
      },
      Button: {
        colorPrimary: '#0A66C2',
        borderRadius: 4,
        fontSize: 12,
        controlHeight: 28,
        paddingInline: 8,
      },
      Form: {
        itemMarginBottom: 8,
      },
      Input: {
        controlHeight: 28,
        fontSize: 12,
      },
      Select: {
        controlHeight: 28,
        fontSize: 12,
      },
      Tabs: {
        horizontalItemGutter: 8,
        horizontalItemPadding: '6px 8px',
      }
    }
  }}
>
  <App />
</ConfigProvider>


    {/* <App /> */}
  </React.StrictMode>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
